var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom card-stretch gutter-b"
  }, [_vm._m(0), _c('Form', {
    attrs: {
      "url": "/restaurante/mesas/update",
      "mesa": _vm.mesa
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Editar Mesa ")])])]);
}];
export { render, staticRenderFns };